<template>
    <div>
        <div class="w-full expense-title-bar border-b-2 border-gray-800 shadow-lg py-6 px-8 cursor-move">
            <div class="flex items-center justify-between w-full">
                <h1 class="text-3xl text-white font-semibold">{{ expense.type.name }}</h1>
                <div @click="$modal.hide('expense-modal')">
                    <inline-svg name="close" classes="fill-current text-white h-6 w-6 ml-5 cursor-pointer"></inline-svg>
                </div>
            </div>
        </div>
        <div class="bg-white">
        	<div class="px-5 py-6 flex items-center justify-center bg-gray-50 border-b border-gray-100 gap-x-14">
				<div>
					<dt class="text-base font-normal text-sm text-gray-700 font-medium">Start Date</dt>
					<dd class="flex items-baseline justify-between md:block lg:flex">
						<div class="mt-1 flex items-baseline text-2xl font-semibold text-indigo-600">
							{{ expense.start_date | date }}
						</div>
					</dd>
				</div>
				<div>
					<dt class="text-base font-normal text-sm text-gray-700 font-medium">End Date</dt>
					<dd class="flex items-baseline justify-between md:block lg:flex">
						<div class="mt-1 flex items-baseline text-2xl font-semibold text-indigo-600">
							{{ expense.end_date | date }}
						</div>
					</dd>
				</div>
				<div>
					<dt class="text-base font-normal text-sm text-gray-700 font-medium">Base Cost PSF</dt>
					<dd class="flex items-baseline justify-between md:block lg:flex">
						<div class="mt-1 flex items-baseline text-2xl font-semibold text-indigo-600">
							{{ formatCurrency(expense.amount_psf, 2) }}
						</div>
					</dd>
				</div>
				<div>
					<dt class="text-base font-normal text-sm text-gray-700 font-medium">Base Monthly Cost</dt>
					<dd class="flex items-baseline justify-between md:block lg:flex">
						<div class="mt-1 flex items-baseline text-2xl font-semibold text-indigo-600">
							{{ formatCurrency(expense.amount_monthly, 0) }}
						</div>
					</dd>
				</div>
				<div>
					<dt class="text-base font-normal text-sm text-gray-700 font-medium">Base Annual Cost</dt>
					<dd class="flex items-baseline justify-between md:block lg:flex">
						<div class="mt-1 flex items-baseline text-2xl font-semibold text-indigo-600">
							{{ formatCurrency(expense.amount_annually, 0) }}
						</div>
					</dd>
				</div>
        	</div>
        	<div class="p-5">
                <multi-line-chart
                    caption="Annual Cost"
                    :data="chartData"
                    bg-color="#ffffff"
                    height="500">
				</multi-line-chart>
        	</div>
        </div>
    </div>
</template>

<script>
    export default {
    	props: {
    		expenseData: {
    			type: [Object, Array],
    			required: true
    		}
    	},

        data() {
            return { 
                expense: this.expenseData,
                selectedTab: 'chart'
            }
        },

        computed: {
            costByYear() {
            	return this.expense.cost_by_term_year.length > 0 ? JSON.parse(this.expense.cost_by_term_year) : {};
            },

            chartData() {
                // return _.map(this.costByYear, (data, year) => {
                //     return { label: year, value: data.total / 100 };
                // });
				return {
					axis: [{
                        title: "Annual Cost",
                        titlepos: "left",
                        numberprefix: "$",
                        divlineisdashed: "1",
                        // maxvalue: "100000",
                        dataset: [{
                            seriesname: "Annual Cost",
                            linethickness: "3",
                            data: _.map(this.costByYear, (data, year) => {
			                    return { value: data.total / 100 };
			                })
                        }]
                    },
                    {
                        title: "Escalation %",
                        axisonleft: "1",
                        titlepos: "left",
                        numdivlines: "8",
                        divlineisdashed: "1",
                        // maxvalue: "25",
                        numbersuffix: "%",
                        dataset: [{
                            seriesname: "Escalation %",
                        	drawAnchors: 1,
                            dashed: "1",
                            data: _.map(this.costByYear, (data) => {
			                    let escalation = _.find(this.expense.escalations, ['year_number', data.year_number]);

			                    return { value: escalation?.amount || "0%" };
			                })
                        }]
                    }],
                    categories: [{
                        category: _.map(this.costByYear, (data) => {
		                    return { label: data.year.toString() };
		                })
                    }]
                }
            }
        },

        methods: {

        }
    }
</script>